export default "__VITE_ASSET__7bb2bb69__"